/* __next_internal_client_entry_do_not_use__ onMenuLinkNavigate auto */ export const onMenuLinkNavigate = ()=>{
    var _document_getElementById;
    (_document_getElementById = document.getElementById('close-mobile-menu')) === null || _document_getElementById === void 0 ? void 0 : _document_getElementById.click();
};
